import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    companyCard: {
      padding: 10,
      gap: '20px',
    },
    cardHeader: {
      gap: '8px',
    },
    companyIcon: {
      color: palette.darkGray,
      width: 32,
      height: 32,
    },
    companyName: {
      fontSize: 22,
      fontWeight: 500,
    },
    companyFields: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    },
    companyInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    companyField: {
      fontWeight: 600,
      fontSize: 14,
      whiteSpace: 'nowrap',
    },
    companyValue: {
      fontSize: 14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    statusValue: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
    },
    editAliasButton: {
      border: `1px solid ${palette.blue}`,
      borderRadius: 16,
      color: palette.blue,
      fontSize: 12,
      padding: '2px 8px',
    },
    doneIcon: { color: palette.green, cursor: 'pointer' },
    closeIcon: { color: palette.red, cursor: 'pointer' },
    changeName: { display: 'contents' },
    editAlias: {
      padding: 0,
      color: palette.blue,
      '& .MuiSvgIcon-root': {
        width: 20,
        height: 20,
      },
    },
  });
